import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getListHistoryRequest: ["type_id", "children_id", "page"],
  getListHistorySuccess: ["listHistory"],
  getListHistoryFailure: null,
});

export const GetListHistoryTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  data: null,
  fetching: null,
  payload: null,
  success: null,
  error: null,
  children_id: null,
  type_id: null,
  page: null,
});

export const GetListHistorySelectors = {
  getData: (state: any) => state.getListHistory.data,
  isFetching: (state: any) => state.getListHistory.fetching,
  isSuccess: (state: any) => state.getListHistory.success,
  hasError: (state: any) => state.getListHistory.error,
};

export const request = (state: any, { children_id, type_id, page }: any) => {
  const updateData = {
    fetching: true,
    success: null,
    error: null,
    children_id,
    payload: null,
    type_id,
    page,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { listHistory } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    listHistory,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    payload: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_LIST_HISTORY_REQUEST]: request,
  [Types.GET_LIST_HISTORY_SUCCESS]: success,
  [Types.GET_LIST_HISTORY_FAILURE]: failure,
});
